import type { CustomerSummary, Paginated, VehicleSummary } from "@autoflow/types";

export type CustomerTag = { id: string; name: string; color: string | null };
export type CustomerNote = {
  id: string; body: string; createdAt: string; updatedAt: string;
  author: { id: string; displayName: string } | null;
};
export type CustomerAttachment = {
  id: string; fileName: string; mimeType: string; size: number; createdAt: string;
};
export type CustomerHistory = {
  id: string; action: string; summary: string; metadata: unknown; createdAt: string;
  actor: { id: string; displayName: string } | null;
};
export type CustomerListItem = CustomerSummary & {
  tagLinks: Array<{ tag: CustomerTag }>;
  _count: { vehicles: number; repairOrders: number };
};
export type CustomerRecord = CustomerSummary & {
  addressLine1: string | null; addressLine2: string | null; city: string | null;
  state: string | null; postalCode: string | null;
  vehicles: VehicleSummary[];
  notes: CustomerNote[];
  tagLinks: Array<{ tag: CustomerTag }>;
  attachments: CustomerAttachment[];
  _count: { repairOrders: number };
};
export type CustomerListResponse = Paginated<CustomerListItem>;

export function customerName(customer: Pick<CustomerSummary, "type" | "salutation" | "firstName" | "lastName" | "companyName">) {
  return customer.type === "BUSINESS"
    ? customer.companyName || "Unnamed business"
    : [customer.firstName, customer.lastName, customer.salutation === "MR" ? "Mr." : customer.salutation === "MS" ? "Ms." : null].filter(Boolean).join(" ") || "Unnamed customer";
}
